// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { version } from '../../package.json';

export const environment = {
  production: false,
  version,
  adal: {
    tenant: 'common',
    clientId: '88183cd7-c14b-4595-848e-3e2c2ec12186',
    endpoints: {
      'https://account-service-ey-dev.azurewebsites.net': '570cfad9-86ea-42b7-990f-99d31febbdce',
      'https://accountappdevstorage.blob.core.windows.net': 'https://storage.azure.com',
    },
    cacheLocation: 'localStorage',
  },
  accountService: {
    //*
    apiUrl: 'https://account-service-ey-dev.azurewebsites.net/api',
    //*/
    /*
    apiUrl: 'http://localhost:50008/api',
    //*/
  },
  azureBlob: {
    apiUrl: 'https://accountappdevstorage.blob.core.windows.net',
  },
  computerVisionService: {
    apiUrl: 'https://japaneast.api.cognitive.microsoft.com/vision/v2.0',
    apiKey: '5a1081a402c2496e95a57bddbaa6e9ca',
  },
  customVisionService: {
    // tslint:disable-next-line
    apiUrl: 'https://account-app-ml.cognitiveservices.azure.com/customvision/v3.0/Prediction/4ea1e043-7aa3-4b20-be66-70566d6bb284/classify/iterations/dev/image',
    predictionKey: 'e19f58dc0bd746d89fafe92c444a17c8',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
